import { useTheme } from '@mui/material';
import { ArrowRight } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import {
  ListItemStyled,
  ListItemButtonStyled,
  ListItemIconStyled,
  ListItemTextStyled,
} from './BenefitItemStyled';

interface BenefitItemProps {
  title: string;
  lookupCode: string;
  disabled?: boolean;
}

export const BenefitItem = ({
  title,
  lookupCode,
  disabled,
}: BenefitItemProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const handleSelection = () => navigate(lookupCode);

  return (
    <ListItemStyled data-testid="benefit-item">
      <ListItemButtonStyled disabled={disabled} onClick={handleSelection}>
        <ListItemTextStyled
          primaryTypographyProps={{
            variant: 'body2',
          }}
          primary={title}
        />
        {!disabled && (
          <ListItemIconStyled>
            <ArrowRight
              size={20}
              weight="bold"
              color={theme.palette.primary.main}
            />
          </ListItemIconStyled>
        )}
      </ListItemButtonStyled>
    </ListItemStyled>
  );
};
